export interface PrimaryFormSubmissionData {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  countryCode: string;
  comment: string;
  inviteeEmails?: string[];
  location: string;
  bookingSource: string;
}

export interface DaniMarioFormSubmissionData {
  companyName?: string;
  numberOfEmployees?: string;
  website?: string;
  linkedInUrl?: string;
}

export type FormSubmissionData = PrimaryFormSubmissionData &
  DaniMarioFormSubmissionData;

export const formKeys = {
  firstName: 'msm_firstName',
  lastName: 'msm_lastName',
  email: 'msm_email',
  phoneNumber: 'msm_phoneNumber',
  comment: 'msm_comment',
  inviteeEmail: 'msm_inviteeEmail',

  companyName: 'msm_companyName',
  numberOfEmployees: 'msm_numberOfEmployees',
  website: 'msm_website',
  linkedInUrl: 'msm_linkedInUrl',
  location: `msm_location`,
};
export const formFieldKeys = Object.values(formKeys);
